
import Authenticator from '../../protocol/Authenticator';
import System from "../../basic/System";
import ConnectionUtil from "../session/ConnectionUtil";

/**
 *
 */
export default class PreviewServerUrlGenerator {
  constructor() {

    /**
     *
     * @type {number}
     */
    this.currentIndex = -1;

    /**
     *
     * @type {boolean}
     */
    this.isSSLPreviewUrl = false;
  }

  /**
   *
   * @param previewServerUrl {String}
   * @param previewServersList {Array.<String>}
   */
  static indexOf(previewServerUrl, previewServersList) {
    if (previewServerUrl && previewServersList && previewServersList.length > 0) {
      return previewServersList.indexOf(previewServerUrl);
    }
    else {
      return -1;
    }
  }

  static isCachedSSLPreviewServerUrl() {
    if (PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL)
      return PreviewServerUrlGenerator.indexOf(PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL, Authenticator.AUTH_DATA.previewServerSSLUrlsList) >= 0;
    else
      return false;
  }

  static isCachedNonSSLPreviewServerUrl() {
    if (PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL)
      return PreviewServerUrlGenerator.indexOf(PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL, Authenticator.AUTH_DATA.previewServerUrlsList) >= 0;
    else
      return false;
  }

  getSSLPreviewServerUrl(isFirstTime) {
    if (System.isBrowserApp()) {
      return ConnectionUtil.getBaseUrl();
    }

    if (isFirstTime) {
      if (PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL && PreviewServerUrlGenerator.isCachedSSLPreviewServerUrl()) {
        this.currentIndex = -1;
        this.isSSLPreviewUrl = true;
        return PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL;
      }
      else {
        this.currentIndex = 0;
        this.isSSLPreviewUrl = true;
        return Authenticator.AUTH_DATA.previewServerSSLUrlsList[this.currentIndex];
      }
    }
    else if (this.isSSLPreviewUrl) {
      if (this.currentIndex < 0)
        this.currentIndex = 0;
      else
        this.currentIndex++;

      if (PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL && PreviewServerUrlGenerator.isCachedSSLPreviewServerUrl()) {
        let cachedUrlIndex = PreviewServerUrlGenerator.indexOf(PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL, Authenticator.AUTH_DATA.previewServerSSLUrlsList);
        if (this.currentIndex === cachedUrlIndex)
          this.currentIndex++;
      }

      if (this.currentIndex >= Authenticator.AUTH_DATA.previewServerSSLUrlsList.length) {
        this.currentIndex = -1;
        this.isSSLPreviewUrl = false;
        return null;
      }
      else {
        this.isSSLPreviewUrl = true;
        return Authenticator.AUTH_DATA.previewServerSSLUrlsList[this.currentIndex];
      }
    }
  }

  getNonSSLPreviewServerUrl(isFirstTime) {
    if (System.isBrowserApp()) {
      return ConnectionUtil.getBaseUrl();
    }
    if (isFirstTime) {
      if (PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL && PreviewServerUrlGenerator.isCachedNonSSLPreviewServerUrl()) {
        this.currentIndex = -1;
        return PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL;
      }
      else {
        this.currentIndex = 0;
        return Authenticator.AUTH_DATA.previewServerUrlsList[this.currentIndex];
      }
    }
    else {
      if (this.currentIndex < 0)
        this.currentIndex = 0;
      else
        this.currentIndex++;

      if (PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL && PreviewServerUrlGenerator.isCachedNonSSLPreviewServerUrl()) {
        let cachedUrlIndex = PreviewServerUrlGenerator.indexOf(PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL, Authenticator.AUTH_DATA.previewServerUrlsList);
        if (this.currentIndex === cachedUrlIndex)
          this.currentIndex++;
      }

      if (this.currentIndex >= Authenticator.AUTH_DATA.previewServerUrlsList.length) {
        this.currentIndex = -1;
        return null;
      }
      else {
        return Authenticator.AUTH_DATA.previewServerUrlsList[this.currentIndex];
      }
    }
  }

  /**
   *
   * @returns {*}
   */
  nextPreviewServerUrl() {
    if (System.isBrowserApp()) {
      return ConnectionUtil.getBaseUrl();
    }

    let previewServerUrl = null;
    if (PreviewServerUrlGenerator.isSSLPreviewEnabled()) {
      previewServerUrl = this.getSSLPreviewServerUrl(false);
    }

    if (!PreviewServerUrlGenerator.isSSLPreviewEnabled() ||
      (PreviewServerUrlGenerator.isSSLPreviewEnabled() && !previewServerUrl)) {
      previewServerUrl = this.getNonSSLPreviewServerUrl(false);
    }
    return previewServerUrl;
  }

  /**
   *
   * @returns {*}
   */
  getPreviewServerUrl() {
    let previewServerUrl = null;
    if (PreviewServerUrlGenerator.isSSLPreviewEnabled()) {
      previewServerUrl = this.getSSLPreviewServerUrl(true);
    }

    if (!previewServerUrl) {
      previewServerUrl = this.getNonSSLPreviewServerUrl(true);
    }

    return previewServerUrl;
  }

  /**
   *
   * @returns {boolean}
   */
  static isSSLPreviewEnabled() {
    return Authenticator.AUTH_DATA.sslRvEnabled;
  }

  /**
   *
   * @returns {string}
   */
  static getCurrentPreviewServerUrl(){
    if (System.isBrowserApp()) {
      return ConnectionUtil.getBaseUrl();
    }
    if(!PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL)
      PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL = Authenticator.AUTH_DATA.previewServerUrl;

    return PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL;
  }
}

/**
 *
 * @type {String}
 */
PreviewServerUrlGenerator.CACHED_PREVIEW_SERVER_URL = null;
